import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

export default function Navbar(props) {

  


  return (
    <div>
  <nav className={`navbar navbar-expand-lg navbar-dark bg-${props.mode==='light' ? 'danger' : 'dark'}`}>
  <Link className="navbar-brand mx-2" to="/">{props.title}</Link>
  <button className="navbar-toggler" type="button"  data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
   
      <li className="nav-item active  mx-2 my-2" aria-current="page">
        <Link className="nav-link" to="/">Home </Link>
      </li>
      <li className="nav-item mx-2 my-2">
        <Link className="nav-link" to="/about">{props.About}</Link>
      </li>
    </ul>
   
    {/* <div className="bg-warning rounded mx-2 my-2" 
    style = {{height : '30px' , width : '30px' ,cursor:'pointer'}}
    onClick= {()=>{props.toggleMode('warning')}}></div>
    <div className="bg-primary rounded mx-2 my-2" 
    style = {{height : '30px' , width : '30px' ,cursor:'pointer'}}
    onClick= {()=>{props.toggleMode('primary')}}></div>
    <div className="bg-success rounded mx-2 my-2" 
    style = {{height : '30px' , width : '30px',cursor:'pointer' }}
    onClick= {()=>{props.toggleMode('success')}}></div> */}


    
 
    <div className={`form-check form-switch text-light mx-2 my-2`}>
  <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onClick={()=>props.toggleMode(null)}/>
  <label className="form-check-label">Enable {props.mode === 'light'?'Dark' : 'Light'} Mode</label>
</div>
  </div>
</nav>
 </div>
  )
}

Navbar.propTypes = {
    title : PropTypes.string ,
    About : PropTypes.string 
}

Navbar.defaultProps = {
    title : 'Set Title',
    About : 'Set About us'  
}